import { render } from "./DescriptorResults.vue?vue&type=template&id=3fd3af7a"
import script from "./DescriptorResults.vue?vue&type=script&lang=js"
export * from "./DescriptorResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__